import { render, staticRenderFns } from "./Personalizations.vue?vue&type=template&id=47e9a94e&scoped=true&"
import script from "./Personalizations.vue?vue&type=script&lang=js&"
export * from "./Personalizations.vue?vue&type=script&lang=js&"
import style0 from "./Personalizations.vue?vue&type=style&index=0&id=47e9a94e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9a94e",
  null
  
)

export default component.exports